import React from 'react';
import SectionHeader from './common/section-header';
import ContactForm from './contact/contact-form';
import ContactInfo from './contact/contact-info';
import ContactMap from './contact/contact-map';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-r from-primary/10 to-secondary/20">
      <div className="container">
        <SectionHeader 
          title="Nehmen Sie Kontakt mit uns auf"
          description="Haben Sie Fragen oder benötigen Sie einen Service? Kontaktieren Sie uns und wir melden uns umgehend bei Ihnen."
        />

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/2 flex flex-col justify-between">
            <ContactForm />
          </div>
          
          <div className="lg:w-1/2 flex flex-col justify-between gap-8">
            <ContactInfo />
            <div className="h-[350px] w-full">
              <ContactMap />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
